import { ConvexProvider, ConvexReactClient } from 'convex/react';
import type { ReactNode } from 'react';

/** One client for the whole app. URL comes from VITE_CONVEX_URL (see vite.config.ts for the local fallback). */
export const convexClient = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL);

export function CirclesConvexProvider({ children }: { children: ReactNode }) {
  return <ConvexProvider client={convexClient}>{children}</ConvexProvider>;
}

/** Re-exported so launcher/builder code imports everything Convex-related from lib/. */
export { api } from '@circles/convex';
export { useMutation, useQuery } from 'convex/react';
